<template>
  <main>
    <div class="container">
      <div class="page_content"
           v-html="htmlContent" />
      <ThePortfolio v-bind="thePortfolioProps" />
    </div>
  </main>
</template>

<script setup lang="ts">
import {
  IThePortfolioProps,
  ThePortfolio,
} from '@/components';
import type { IPortfoliosPage } from '@/types';

const { findOne } = useStrapi();
const response = await findOne<IPortfoliosPage>('page-portfolio', {
  populate: 'deep',
});

const data = response.data as unknown as IPortfoliosPage;

useHead(usePageSeoMeta(data));

const htmlContent = data.content;

const portfoliosStore = usePortfoliosStore();

onMounted(() => {
  portfoliosStore.getAll();
});

const thePortfolioProps = computed<IThePortfolioProps>(() => {
  return {
    hideMoreButton: true,
  };
});
</script>
